import React from 'react';
import { AlertOctagon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-8 md:py-14 bg-navy-950 text-center px-4" data-id="element-25">
      <div className="container mx-auto max-w-3xl" data-id="element-26">
        <div className="mb-6 md:mb-10" data-id="element-27">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-4 md:mb-6 flex items-center justify-center gap-2 md:gap-3" data-id="element-28">
            <AlertOctagon className="w-6 h-6 md:w-7 md:h-7 text-red-500" data-id="element-29" />
            Esto no es para todos
          </h2>

          <div className="space-y-2 md:space-y-3 text-base md:text-lg text-slate-300" data-id="element-30">
            <p data-id="element-31">Si querés seguir igual… No hagas nada.</p>
            <p data-id="element-32">
              Si te conformás con apagar incendios… Este sistema no es para vos.
            </p>
            <p className="text-lg md:text-xl font-bold text-white pt-2 md:pt-4" data-id="element-33">
              Pero si querés dar un salto real…
            </p>
            <p className="text-xl md:text-2xl font-bold text-gold-400" data-id="element-34">
              👉 Entonces sí.
            </p>
          </div>
        </div>

        <div className="bg-navy-900 p-4 md:p-8 rounded-2xl border border-navy-800 mb-5 md:mb-8" data-id="element-35">
          <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4" data-id="element-36">
            ⚓ Este es el momento
          </h3>
          <p className="text-base md:text-lg text-slate-300 mb-3 md:mb-4" data-id="element-37">
            Porque el próximo charter va a llegar igual.
          </p>
          <p className="text-base md:text-lg text-slate-300 mb-2 md:mb-3" data-id="element-38">
            La única diferencia es:
          </p>
          <div className="flex flex-col sm:flex-row gap-2 md:gap-3 justify-center mb-4 md:mb-6" data-id="element-39">
            <span className="bg-navy-950 px-3 py-1.5 md:px-4 md:py-2 rounded-lg border border-navy-700 text-slate-400 text-sm md:text-base" data-id="element-40">
              👉 Si va a ser otro caos…
            </span>
            <span className="bg-gold-500/10 px-3 py-1.5 md:px-4 md:py-2 rounded-lg border border-gold-500/30 text-white font-bold text-sm md:text-base" data-id="element-41">
              👉 O el punto donde todo empieza a funcionar.
            </span>
          </div>

          <h3 className="text-xl md:text-2xl font-heading font-black text-white mb-3 md:mb-4" data-id="element-42">
            🚀 Tomá control ahora
          </h3>
          <div className="space-y-1.5 md:space-y-2 text-slate-300 mb-4 md:mb-6 text-sm md:text-base" data-id="element-43">
            <p data-id="element-44">No esperes a que los problemas se repitan otra vez.</p>
            <p data-id="element-45">No esperes a sentir el mismo estrés en el próximo servicio.</p>
            <p className="text-lg md:text-xl font-bold text-white mt-2 md:mt-4" data-id="element-46">
              👉 Hacé el cambio ahora.
            </p>
          </div>

          <blockquote className="text-lg md:text-2xl font-heading font-bold text-gold-400 italic mb-5 md:mb-8" data-id="element-47">
            💥 "No solo vas a ordenar tu trabajo…
            <br data-id="element-48" />
            vas a ordenar todo el barco."
          </blockquote>

          <div className="space-y-4 md:space-y-6" data-id="element-49">
            <p className="text-lg md:text-xl text-white font-medium" data-id="element-50">
              👉 Descargá Charter Command System™ y transformá tu forma de
              trabajar desde hoy.
            </p>

            <CTAButton data-id="element-51" />

            <p className="text-base md:text-lg text-slate-400 mt-4 md:mt-6" data-id="element-52">
              Convertite en el capitán que dirige un sistema…
              <br data-id="element-53" />
              <span className="text-white font-bold" data-id="element-54">
                No en el que sobrevive al caos.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}